module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYWMxNWM2MjZkM2QwNGFiYTQ5ZDY4ZDc5ODA1MjVhYmMucG5nIjs="